var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChosedPoint = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  fill: "none",
  viewBox: "0 0 36 36"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1FC8B6",
  d: "M18.21 27.763c5.241 0 9.49-4.241 9.49-9.474 0-5.232-4.249-9.474-9.49-9.474s-9.49 4.242-9.49 9.474 4.249 9.474 9.49 9.474"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  stroke: "#0F0",
  strokeMiterlimit: 10,
  strokeWidth: 0.359,
  d: "M18.21 26.486c4.534 0 8.21-3.67 8.21-8.197s-3.676-8.196-8.21-8.196S10 13.763 10 18.29c0 4.527 3.676 8.196 8.21 8.196Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 9.998,
  x2: 26.422,
  y1: 18.288,
  y2: 18.288,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1FC828"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#011F00"
})), /*#__PURE__*/React.createElement("filter", {
  id: "a",
  width: 34.98,
  height: 34.948,
  x: 0.72,
  y: 0.815,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_0_528",
  stdDeviation: 4
})))));
export { SvgChosedPoint as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfZl8wXzUyOCkiPgo8cGF0aCBkPSJNMTguMjEgMjcuNzYzNEMyMy40NTExIDI3Ljc2MzQgMjcuNyAyMy41MjE3IDI3LjcgMTguMjg5NEMyNy43IDEzLjA1NyAyMy40NTExIDguODE1MzcgMTguMjEgOC44MTUzN0MxMi45Njg4IDguODE1MzcgOC43MTk5NyAxMy4wNTcgOC43MTk5NyAxOC4yODk0QzguNzE5OTcgMjMuNTIxNyAxMi45Njg4IDI3Ljc2MzQgMTguMjEgMjcuNzYzNFoiIGZpbGw9IiMxRkM4QjYiLz4KPC9nPgo8cGF0aCBkPSJNMTguMjEgMjYuNDg1NUMyMi43NDQyIDI2LjQ4NTUgMjYuNDIgMjIuODE2IDI2LjQyIDE4LjI4OTRDMjYuNDIgMTMuNzYyNyAyMi43NDQyIDEwLjA5MzIgMTguMjEgMTAuMDkzMkMxMy42NzU3IDEwLjA5MzIgMTAgMTMuNzYyNyAxMCAxOC4yODk0QzEwIDIyLjgxNiAxMy42NzU3IDI2LjQ4NTUgMTguMjEgMjYuNDg1NVoiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8wXzUyOCkiIHN0cm9rZT0iIzAwRkYwMCIgc3Ryb2tlLXdpZHRoPSIwLjM1OTQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPgo8ZGVmcz4KPGZpbHRlciBpZD0iZmlsdGVyMF9mXzBfNTI4IiB4PSIwLjcxOTk3MSIgeT0iMC44MTUzNjkiIHdpZHRoPSIzNC45OCIgaGVpZ2h0PSIzNC45NDgxIiBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiIGNvbG9yLWludGVycG9sYXRpb24tZmlsdGVycz0ic1JHQiI+CjxmZUZsb29kIGZsb29kLW9wYWNpdHk9IjAiIHJlc3VsdD0iQmFja2dyb3VuZEltYWdlRml4Ii8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW49IlNvdXJjZUdyYXBoaWMiIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9InNoYXBlIi8+CjxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjQiIHJlc3VsdD0iZWZmZWN0MV9mb3JlZ3JvdW5kQmx1cl8wXzUyOCIvPgo8L2ZpbHRlcj4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzBfNTI4IiB4MT0iOS45OTc1IiB5MT0iMTguMjg4NSIgeDI9IjI2LjQyMjUiIHkyPSIxOC4yODg1IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiMxRkM4MjgiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMDExRjAwIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";